<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.151827 9.38248C0.340591 9.57775 0.646639 9.57775 0.835403 9.38248L4.86341 5.21582C5.05218 5.02056 5.05218 4.70397 4.86341 4.50871L0.835403 0.342044C0.646639 0.146782 0.340591 0.146782 0.151827 0.342044C-0.0369372 0.537306 -0.0369372 0.853889 0.151827 1.04915L3.83805 4.86226L0.151827 8.67538C-0.0369372 8.87064 -0.0369372 9.18722 0.151827 9.38248Z"
  />
</template>
